import { render, staticRenderFns } from "./DifficultyIndicator.vue?vue&type=template&id=3c28ea00&scoped=true"
import script from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
export * from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
import style0 from "./DifficultyIndicator.vue?vue&type=style&index=0&id=3c28ea00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28ea00",
  null
  
)

export default component.exports